export enum ErrorEvent {
  /** CoauthorGallery: The information received about the client is invalid */
  InvalidClientInfo = 'InvalidClientInfo',
  /** PermissionsPanel: Zero personas returned from Permissions API */
  GetPermissionsResponseError = 'GetPermissionsResponseError',
  /** Issues when making getUserPhoto call */
  GetUserPhotoError = 'GetUserPhotoError',
  /** ShareService did not load correctly */
  ShareServiceLoadError = 'ShareServiceLoadError'
}
